<template>
  <div class="member-search">
    <el-form ref="searchForm" :model="searchForm" label-width="100px">
      <el-row>
        <el-col :lg="8" :offset="2">
          <el-form-item label="品牌:">
            <el-radio-group v-model="searchForm.brandId" @change="checkInput">
              <el-radio :label="1">N牌</el-radio>
              <el-radio :label="2">S牌</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :offset="2">
          <el-form-item label="卡號:">
            <el-input v-model="searchForm.cardNumber"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="8" :offset="2">
          <el-form-item label="姓名:">
            <el-input v-model="searchForm.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :offset="2">
          <el-form-item label="生日:">
            <el-select v-model="searchForm.birthday">
              <el-option
                v-for="item in options"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="8" :offset="2">
          <el-form-item label="店櫃:">
            <el-select v-model="searchForm.shop" placeholder="">
              <el-option
                v-for="item in shops"
                :key="item._key"
                :label="item.name"
                :value="item._key"
                clearable
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :offset="2">
          <el-button type="primary" @click="fetch">
            <i class="el-icon-search"></i> 查詢</el-button
          >
        </el-col>
      </el-row>
    </el-form>

    <el-row>
      <el-row>
        <el-col :lg="6" :offset="18">
          <el-button type="primary" @click="dialogFormVisible = true">報表</el-button>
          <el-dialog title="報表" :visible.sync="dialogFormVisible" width="40%" center>
            <el-form :v-model="excelForm" :rules="rules" label-width="90px">
              <el-row justify="center" align="center">
                <el-col :span="22" :offset="2">
                  <el-form-item label="品牌:" prop="brand_id">
                    <el-radio-group
                      v-model.number="excelForm.brand_id"
                      @change="excelCheckInput"
                    >
                      <el-radio :label="1">N牌</el-radio>
                      <el-radio :label="2">S牌</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="22" :offset="2">
                                <el-form-item label="日期間格:">
                                    <el-date-picker v-model="excelForm.date" type="daterange" range-separator="到" start-placeholde="開始日期" end-placeholde="結束日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                <el-col :span="22" :offset="2">
                  <el-form-item label="生日:">
                    <el-select v-model="excelForm.birthday">
                      <el-option
                        v-for="item in options"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="22" :offset="2">
                  <el-form-item label="店櫃:">
                    <el-select v-model="excelForm.shopKey" filterable>
                      <el-option
                        v-for="item in excelShops"
                        :label="item.name"
                        :value="item._key"
                        :key="item._key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="22" :offset="2">
                  <el-button type="primary" size="default" @click="checkMemberExcel">確認excel項目</el-button>
                  
                </el-col>
                    <el-col :lg="22" :offset="2" v-if="isCheck">
          <el-form-item label="頁數:">
            <el-select v-model="excelForm.page_limit">
              <el-option
                v-for="item in pages"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
              </el-row>
            </el-form>
            <el-progress :text-inside="true" :stroke-width="26" :percentage="percentData" v-if="start"></el-progress>

            <el-row justify="center" align="center"> </el-row>

            <span slot="footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="downExcel">匯 出</el-button>
            </span>
          </el-dialog>
        </el-col>
      </el-row>
      <el-col :lg="22">
        <el-table
          :data="memberList.slice((currentPage - 1) * pagesize, currentPage * pagesize)"
          :header-cell-style="tableHeaderColor"
          empty-text="暫無數據"
        >
          <el-table-column
            align="center"
            header-align="center"
            prop="brand_id"
            label="品牌"
          >
            <template slot-scope="scope">
              {{ scope.row.brand_id == 1 ? "N牌" : "S牌" }}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="name" label="姓名">
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="phone" label="電話">
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="address"
            label="地址"
          >
          </el-table-column>
          <el-table-column label="詳細" align="center" header-align="center">
            <template slot-scope="scope">
              <el-button
                type="info"
                icon="el-icon-more"
                @click="detailTabs(scope.$index, scope.row)"
                circle
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total1"
          @current-change="current_change"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import moment from "moment"
import toExcel from "@/excel/json2excel"

export default {
  name: "search",

  data() {
    return {
      searchForm: {
        brandId: null,
        cardNumber: "",
        birthday: "",
        name: "",
        shop: "",
        brand: "",
      },
      excelForm: {
        "date": [],
        brand_id: 1,
        birthday: "",
        shop_key: "",
        page_limit: 0,
      },
      form: {},
      excelBrandId: {},
      shops: [],
      excelShops: [],
      memberList: [],
      total1: 0,
      isCheck: false,
      start: false,
      percentData: 0,
      currentPage: 1,
      pagesize: 10,
      startDay: '',
      endDay: '',
      diaFormVisble: false,
      dialogVisible: false,
      dialogFormVisible: false,
      strDate: "",
      pages: [],
      memberExcel: [],
      options: [
        {
          label: "1月",
          value: "1月",
        },
        {
          label: "2月",
          value: "2月",
        },
        {
          label: "3月",
          value: "3月",
        },
        {
          label: "4月",
          value: "4月",
        },
        {
          label: "5月",
          value: "5月",
        },
        {
          label: "6月",
          value: "6月",
        },
        {
          label: "7月",
          value: "7月",
        },
        {
          label: "8月",
          value: "8月",
        },
        {
          label: "9月",
          value: "9月",
        },
        {
          label: "10月",
          value: "10月",
        },
        {
          label: "11月",
          value: "11月",
        },
        {
          label: "12月",
          value: "12月",
        },
      ],
      rules: {
        brand_id: [{ required: true, message: "請輸入品牌", trigger: "blur" }],
      },
    }
  },
  computed: mapGetters([
    "getMemberList",
    "getShopList",
    "getMemberExcel",
    "getCheckMemberExcel",
    "getShopDetail",
    "UserInfo",
  ]),
  methods: {
    ...mapActions([
      "fetchMemberList",
      "fetchShop",
      "fetchMemberExcel",
      "fetchCheckMemberExcel",
      "fetchShopDetail",
      "fetchUserInfo",
    ]),
    async fetch() {
      const data = {
        brand_id: this.searchForm.brandId,
        card_number: this.searchForm.cardNumber,
        name: this.searchForm.name,
        birthday: this.searchForm.birthday,
        shop_key: this.searchForm.shop,
      }

      await this.$store.dispatch("fetchMemberList", data)
      this.memberList = this.getMemberList
      this.total1 = this.memberList.length
    },
    async queryShop() {
      if (this.searchForm.brandId != null) {
        this.form = {
          brand_id: this.searchForm.brandId,
        }
        
      } else {
        this.form = {}
      }
     
      
      await this.$store
        .dispatch("fetchShop", this.form)
        .then(() => {
          this.shops = this.getShopList
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async excelQueryShop() {
      
      if (this.excelForm.brand_id != null) {
        this.excelBrandId = {
          brand_id: this.excelForm.brand_id,
        }
      } else {
        this.excelBrandId = {}
      }
      
      await this.$store
        .dispatch("fetchShop", this.excelBrandId)
        .then(() => {
          this.excelShops = this.getShopList
        })
        .catch((err) => {
          console.log(err)
        })
    },

    checkInput() {
      this.queryShop()
    },
    excelCheckInput() {
      this.excelQueryShop()
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return `background-color: gray;color: #000;`
      }
    },
    detailTabs: function (index, row) {
      this.$emit("detailTabs", row._key)
    },
    openDia() {
      this.diaFormVisble = true
    },
    async downExcel() {
      this.start = true
         await this.$message({
        type: 'info',
        message: '完成需等待時間完成匯出',
      })
      if (this.excelForm.date.length != 0) {
                this.startDay = moment(this.excelForm.date[0]).format('YYYY-MM-DD')
                this.endDay = moment(this.excelForm.date[1]).format('YYYY-MM-DD')
            } else {
                this.startDay = ''
                this.endDay = ''
            }
      this.percents()
      const data = {
        start_date: this.startDay,
        end_date: this.endDay,
        brand_id: this.excelForm.brand_id,
        birthday: this.excelForm.birthday,
        shop_key: this.excelForm.shopKey,
        page_limit: this.excelForm.page_limit,
      }
      await this.$store.dispatch("fetchMemberExcel", data)
      this.memberExcel = this.getMemberExcel
      for (let i = 0; i < this.memberExcel.length; i++) {
        if (this.memberExcel[i].shop_key != null) {
          const data = {
            _key: this.memberExcel[i].shop_key,
          }
          await this.$store.dispatch("fetchShopDetail", data)

          if (this.getShopDetail != null) {
            this.memberExcel[i].shop_name = this.getShopDetail.name
          }
        }

        if (this.memberExcel[i].brand_id == 1) {
          if (this.memberExcel[i].level == 1) {
            this.memberExcel[i].level_name = "白金"
          } else if (this.memberExcel[i].level == 2) {
            this.memberExcel[i].level_name = "尊爵"
          } else if (this.memberExcel[i].level == 0) {
            this.memberExcel[i].level_name = "非會員"
          }
          console.log(this.memberExcel[i].level)
        } else if (this.memberExcel[i].brand_id == 2) {
          if (this.memberExcel[i].level == 1) {
            this.memberExcel[i].level_name = "芙蓉"
          } else if (this.memberExcel[i].level == 2) {
            this.memberExcel[i].level_name = "金鑽"
          } else if (this.memberExcel[i].level == 0) {
            this.memberExcel[i].level_name = "非會員"
          }
          console.log(this.memberExcel[i].level)
        }

        if (this.memberExcel[i].user_key != null) {
          const data = {
            _key: this.memberExcel[i].user_key,
          }
          await this.$store.dispatch("fetchUserInfo", data)
          if (this.UserInfo != null) {
            this.memberExcel[i].user_name = this.UserInfo.name
          }
        }
      }
      this.DataExcel(this.memberExcel)
      this.start = false
    },

     async checkMemberExcel() {
      if (this.excelForm.date.length != 0) {
                this.startDay = moment(this.excelForm.date[0]).format('YYYY-MM-DD')
                this.endDay = moment(this.excelForm.date[1]).format('YYYY-MM-DD')
            } else {
                this.startDay = ''
                this.endDay = ''
            }
      const data = {
        start_date: this.startDay,
        end_date: this.endDay,
        brand_id: this.excelForm.brand_id,
        birthday: this.excelForm.birthday,
        shop_key: this.excelForm.shopKey,
      }
      await this.$store.dispatch("fetchCheckMemberExcel", data)
      let page = 0
      if(this.getCheckMemberExcel % 1000 == 0) {
          page = this.getCheckMemberExcel / 1000
      }else {
        page = Math.ceil(this.getCheckMemberExcel / 1000)
      }
      for (let i = 0; i < page; i++) {
        this.pages.push({
          "label": i+1,
          "value": i+1,
        });
        
      }
      this.isCheck = true;
     },
    percents(){
     
        this.percentData += 20
        var self = this
        setTimeout(function () {
          self.percentData += 20
        }, 10000)
        setTimeout(function () {
          self.percentData += 20
        }, 20000)
        setTimeout(function () {
          self.percentData += 20
        }, 30000)
        setTimeout(function () {
          self.percentData += 20
        }, 40000)
        
    
       
    },
    async DataExcel(datas) {
      const th = [
        "姓名",
        "生日",
        "卡號",
        "卡別",
        "入會日期",
        "升等日期",
        "到期日期",
        "聯絡電話",
        "區域",
        "城市",
        "地址",
        "店櫃",
        "店櫃key",
        "美容師",
        "累積消費金額",
        "點數",
      ]
      const filterVal = [
        "name",
        "birthday",
        "card_number",
        "level_name",
        "make_day",
        "vip_start_at",
        "vip_end_at",
        "phone",
        "area",
        "city",
        "address",
        "shop_name",
        "shop_key",
        "user_name",
        "consumption",
        "point",
      ]
      const data = datas.map((v) => filterVal.map((k) => v[k]))
      let tableName = "會員"

      const [fileName, fileType, sheetName] = [tableName, "xlsx", tableName]

      const type = 'member'
      toExcel({
        th,
        data,
        fileName,
        fileType,
        sheetName,
        type,
      })
    },
  },
  created() {
    this.queryShop()
    this.excelQueryShop()
  },
};
</script>

<style lang="scss" scoped>
.member-search {
  font-weight: bold
 
}
</style>
